import { KeenSliderOptions } from 'keen-slider'

const animation = { duration: 20000, easing: (t: number) => t }

const keenConfig = (
    spacing = 70,
    hasAnimation = true,
    direction: "left" | "right" = "right",
    step = 5,
    loop = true,
): KeenSliderOptions => ({
    loop: loop,
    mode: "free",
    renderMode: "performance",
    slides: { perView: "auto", spacing },
    drag: true,
    ...(hasAnimation && {
        created(s) {
            let isDragging = false
            
            const safeAnimate = () => {
                if (!isDragging && s?.track?.details && typeof s.moveToIdx === 'function') {
                    const targetIdx = s.track.details.abs + step * (direction === "right" ? 1 : -1)
                    s.moveToIdx(targetIdx, true, animation)
                }
            }
            
            s.on('dragStarted', () => { isDragging = true; })
            s.on('dragEnded', () => { 
                isDragging = false
                setTimeout(safeAnimate, 300)
            })
            s.on('animationEnded', safeAnimate)
            s.on('animationStopped', () => {
                if (s && s.track.details && !isDragging) {
                    setTimeout(() => {
                        safeAnimate()
                    }, 100)
                }
            })
            
            setTimeout(safeAnimate, 100)
        }
    }),
})

export default keenConfig